export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";